import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@material-ui/core";
import { ReactComponent as BackIcon } from "assets/icons/arrow-left.svg";
import styled from "styled-components";
import MainTabsBase from "components/mainTabs/MainTabs";
import "./fundraising.scss";
import Loader from "components/loader/Loader";
import { fetchAnalytics, fetchDonors } from "./fundraisingSlice";
import DonorsList from "./DonorsList";
import UpdateForm from "./UpdateForm";
import Analytics from "./Analytics";

const MainTabs = styled(MainTabsBase)`
  width: 100%;
`;

const BackBtn = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  span {
    padding-left: 8px;
    color: #2555ef;
    font-size: 15px;
    font-family: var(--FundraisingBackBtnSpanFont-family);
  }
`;
const PageTitle = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #002e5c;
  font-family: var(--FundraisingPageTitleFont-family);
  margin-left: 12px;
`;

const TAB_OPTIONS = [
  { title: "Analytics",   value: "analytics",   width: "130px" },
  { title: "Donors",      value: "donors",       width: "130px" },
  { title: "Post Update", value: "post_update",  width: "130px" },
];

const CampaignDetail = ({ campaignId, onBack }) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { analytics, donors, loading, currentCampaign } = useSelector((s) => s.fundraising);
  const [tab, setTab] = useState("analytics");

  useEffect(() => {
    const load = async () => {
      const token = await getAccessTokenSilently();
      dispatch(fetchAnalytics({ id: campaignId, token }));
      dispatch(fetchDonors({ id: campaignId, token, page: 1 }));
    };
    load();
  }, [campaignId]); // eslint-disable-line react-hooks/exhaustive-deps

  const updatesCount = (currentCampaign?.updates ?? analytics?.updates ?? []).length;

  const tabsWithCount = TAB_OPTIONS.map((t) =>
    t.value === "donors"
      ? { ...t, title: `Donors (${donors?.total ?? analytics?.donor_count ?? 0})` }
      : t.value === "post_update"
      ? { ...t, title: `Post Update (${updatesCount})` }
      : t
  );

  return (
    <div className="fundraising-detail pt-5">
      <div className="header mt-5">
        <BackBtn onClick={onBack}>
          <BackIcon />
          <span>Back</span>
        </BackBtn>
        <PageTitle>{analytics?.title || "Campaign Detail"}</PageTitle>
      </div>

      <MainTabs
        className="mt-10"
        tabs={tabsWithCount}
        activeTab={tab}
        onTabsChange={(t) => setTab(t.value)}
      />

      <div style={{ padding: "24px 0" }}>
        {loading && !analytics ? (
          <div className="user__loader" style={{ height: 320 }}>
            <Loader />
          </div>
        ) : (
          <>
            {tab === "analytics"   && <Analytics analytics={analytics} />}
            {tab === "donors"      && <DonorsList donors={donors} campaignId={campaignId} />}
            {tab === "post_update" && <UpdateForm campaignId={campaignId} />}
          </>
        )}
      </div>
    </div>
  );
};

export default CampaignDetail;
